export default "__VITE_ASSET__12f8602d__"